import {FC} from "react";
import {DescriptionWrapper, IconContainer, ImageWrapper} from "./styles";
import {Tooltip} from "react-tooltip";
import {IFiltersTop} from "./types";
import {ITypeRadar} from "../../types";
import {
  IFintechFilters,
  IFintechWeakSignalsFilters,
} from "../../pages/Fintech/FintechDashboard.type";
import {IdashboardFilters} from "../../pages/Dashboard/Dashboard.type";
import {IEsgFilters} from "../../pages/Esg/EsgDashboard.type";
import {IStateInitiativeFilters} from "../../pages/StateInitiative/StateInitiative.type";

interface IProps {
  item: IFiltersTop;
  typeRadar: ITypeRadar;
  filters:
    | IFintechFilters
    | IdashboardFilters
    | IEsgFilters
    | IStateInitiativeFilters;
  typedFilters:
    | IFintechFilters
    | IdashboardFilters
    | IEsgFilters
    | IStateInitiativeFilters;
  filterWeakSignals?: IFintechWeakSignalsFilters;
  onFilterChange: <T>(filter: string, value?: T) => void;
  // isActive?: boolean;
}

let count = 0;
export const FilterItemSingle: FC<IProps> = ({
  item,
  onFilterChange,
  filterWeakSignals,
  typedFilters,
}) => {
  const toggleFilter = (filter: string, value?: boolean) => {
    onFilterChange(filter, value);
  };
  const isActive =
    item.id in typedFilters &&
    (typedFilters as Record<string, any>)[item.id]?.turnOn
      ? true
      : false;
  return (
    <IconContainer
      key={`${item.id}-${count}`}
      data-tooltip-id={item.id}
      data-tooltip-content={item.tooltip}
      onClick={() =>
        filterWeakSignals?.weak_signal ? null : toggleFilter(item.id, !isActive)
      }
      isActive={isActive}
      disabled={filterWeakSignals?.weak_signal ? true : false}
    >
      <ImageWrapper
        disabled={filterWeakSignals?.weak_signal ? true : false}
        className={isActive ? "active" : ""}
      >
        <img
          src={item.icon}
          width={"100%"}
          height={"100%"}
          style={isActive ? {opacity: 1} : {opacity: 0.4}}
          alt={"alt"}
        />
      </ImageWrapper>
      {filterWeakSignals?.weak_signal ? null : (
        <Tooltip
          id={item.id}
          className="tooltip custom-tooltip"
          place={"bottom"}
          style={{userSelect: "none"}}
          noArrow
        />
      )}
      <DescriptionWrapper
        isactive={isActive?.toString() || "false"}
        disabled={filterWeakSignals?.weak_signal ? true : false}
      >
        <span>{item.tooltip}</span>
      </DescriptionWrapper>
    </IconContainer>
  );
};
